import { RDEqipEligibilityWetlandCompliance } from '@cibo/core'
import { Markdown, ResourceDetailFeature, ResourceDetailFeatureTaskEditorProps } from '@cibo/ui'
import { Stack, Typography } from '@mui/material'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { useBatchedFields } from '../../../../queries'
import { BooleanRollupRowTable } from '../../BooleanRollupRowTable'

export const RDEqipEligibilityWetlandComplianceResourceDetailFeature: ResourceDetailFeature<RDEqipEligibilityWetlandCompliance> =
  {
    traitId: 'eqipEligibilityWetlandCompliance',
    TaskEditor: (
      props: ResourceDetailFeatureTaskEditorProps<RDEqipEligibilityWetlandCompliance>
    ) => {
      const { t } = useTranslation(
        '@cibo/landmanager/RDEqipEligibilityWetlandComplianceResourceDetailFeature'
      )

      const fieldModels = useBatchedFields(props.resourceIds)
      return (
        <Stack spacing={3} flex={1}>
          <Markdown
            overrides={{
              em: {
                component: ({ children }: { children: ReactNode }) => (
                  <Typography variant="body2" color="text.secondary" component="span">
                    {children}
                  </Typography>
                ),
              },
            }}
          >
            {t('question', {
              context: props.userRole,
              name: props.ownerName,
              count: fieldModels.data?.length,
              period: props.detailRequirements?.[0]?.year,
            })}
          </Markdown>

          <BooleanRollupRowTable<RDEqipEligibilityWetlandCompliance>
            answerValues={{
              yes: {
                value: true,
                label: <Typography color="error">{t('nonCompliant')}</Typography>,
              },
              no: {
                value: false,
                label: <Typography color="success">{t('compliant')}</Typography>,
              },
            }}
            detailKey="wetlandCompliance"
            ns="@cibo/landmanager/RDEqipEligibilityWetlandComplianceResourceDetailFeature"
            {...props}
          />
        </Stack>
      )
    },
  }
